import { Grid } from "@mui/material";
import React from "react";
import Title from "../ReusableComponents/title";
import "../../assets/css/competition.scss";



const CompetitionRule = ({ props, RulesData }) => {
  console.log("RulesData", RulesData.challenge.rules);
  return (
    <div className="PageContainer">
      <div className="Container-p-20">
        <Title six>Competition Rules</Title>
        <Grid container className="mtt-20">
          <Grid xs={5}>
                  <Grid
                    container
                    alignItems="center"
                    className="gapp-10 mbb-20"
                  >
                    <Grid className="RulesDetail">
                      <div
                        style={{ color: "white" }}
                        dangerouslySetInnerHTML={{
                          __html: RulesData.challenge.rules
                        }}
                      ></div>
                    </Grid>
                  </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default CompetitionRule;
